import Vue from 'vue'
import Router from 'vue-router'
import { BackToLogin, BackToDashboard } from './middlewares/middlewares'
/* Global Components */
/* -----Offset Heading----- */
import OffsetHeading from '@/components/custom-components/OffsetHeading'
Vue.component('offset-heading', OffsetHeading)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/Login/Login.vue'),
      name: 'Login',
      meta: {
        middleware: BackToDashboard,
        nav: {
          display: false,
          name: 'Login',
          isLocationMenu: false
        }
      }
    },
    {
      path: '/brands',
      component: () => import('@/views/Brand/Brand.vue'),
      name: 'Brands',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Brands',
          icon: 'fa-tags',
          isLocationMenu: false
        }
      }
    },
    {
      path: '/categories',
      component: () => import('@/views/Category/Category.vue'),
      name: 'Category',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Categories',
          icon: 'fa-object-group',
          isLocationMenu: false
        }
      }
    },
    {
      path: '/products',
      component: () => import('@/views/Product/Product.vue'),
      name: 'Products',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Products',
          icon: 'fa-tags',
          isLocationMenu: false
        }
      }
    },
    {
      path: '/terpene',
      component: () => import('@/views/Terpene/Terpene.vue'),
      name: 'Terpene',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Terpene',
          icon: 'fa-atom',
          isLocationMenu: false
        }
      }
    },
    {
      path: '/aroma',
      component: () => import('@/views/Aroma/Aroma.vue'),
      name: 'Aroma',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Aroma',
          icon: 'fa-wind',
          isLocationMenu: false
        }
      }
    },
    {
      path: '/colour',
      component: () => import('@/views/Color/Color.vue'),
      name: 'Colour',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Colour',
          icon: 'fa-palette',
          isLocationMenu: false
        }
      }
    },
    {
      path: '/flavour',
      component: () => import('@/views/Flavour/Flavour.vue'),
      name: 'Flavour',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Flavour',
          icon: 'fa-grin-tongue',
          isLocationMenu: false
        }
      }
    },
    {
      path: '/mood',
      component: () => import('@/views/Moods/Moods.vue'),
      name: 'Mood',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Mood',
          icon: 'fa-laugh-beam',
          isLocationMenu: false
        }
      }
    },

    {
      path: '/allergen',
      component: () => import('@/views/Allergen/Allergen.vue'),
      name: 'Allergen',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Allergen',
          icon: 'fa-allergies',
          isLocationMenu: false
        }
      }
    },

    {
      path: '/location-product',
      component: () => import('@/views/LocationProduct'),
      name: 'LocationProducts',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Location Products',
          icon: 'fa-map-marker-alt',
          isLocationMenu: true
        }
      }
    },

    {
      path: '/location-category',
      component: () => import('@/views/LocationCategory/LocationCategory.vue'),
      name: 'LocationCategory',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Location Categories',
          icon: 'fa-object-group',
          isLocationMenu: true
        }
      }
    },

    {
      path: '/database-selection',
      component: () =>
        import('@/views/DatabaseSelection/DatabaseSelection.vue'),
      name: 'DatabaseSelection',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Database Selection',
          icon: 'fa-database',
          isLocationMenu: true
        }
      }
    },

    {
      path: '/partial-sync',
      component: () =>
        import('@/views/PartialSync/PartialSync.vue'),
      name: 'PartialSync',
      meta: {
        middleware: BackToLogin,
        nav: {
          display: true,
          name: 'Partial Sync',
          icon: 'fa-sync',
          isLocationMenu: true
        }
      }
    },

    {
      path: '/login',
      component: () => import('@/views/Login/Login.vue'),
      meta: {
        middleware: BackToDashboard,
        nav: {
          display: false,
          name: 'Login',
          isLocationMenu: false
        }
      }
    },
    {
      path: '*',
      component: () => import('@/views/pageNotFound.vue'),
      name: 'Page Not Found',
      meta: {
        // middleware: BackToLogin,
      }
    }
  ]
})
export default router
